import { Button } from '../2022-component-library';
import { useBreakpoints } from '../helpers/useBreakpoints';

const ResponsiveButton = ({ children, ...props }) => {
  const { breakpoints } = useBreakpoints();
  return (
    <Button
      textTransform='uppercase'
      fontFamily='Plus Jakarta Sans'
      fontWeight='bold'
      width={props.width || breakpoints('10em', '15em', '20em')}
      padding='12px 24px'
      {...props}
    >
      {children}
    </Button>
  );
};

export default ResponsiveButton;
